import { loader } from "graphql.macro";

const queries = {
  GET_EMPLOYEE_PROFILE: loader("./getEmployeeProfile.gql"),
  GET_EMPLOYEE_PROFILES: loader("./getEmployeeProfiles.gql"),
  GET_PAY_PERIOD: loader("./getPayPeriod.gql"),
  PARTNER_CONFIG_QUERY: loader("./partnerConfigQuery.gql"),
  GET_ASSOCIATED_LOCATIONS: loader("./getAssociatedLocations.gql"),
  GET_ADMINS_QUERY: loader("./getAdmins.gql"),
  GET_USER_ROSTER_FILES_QUERY: loader("./getUserRosterFiles.gql"),
  GET_NET_EARNINGS_FILES_QUERY: loader("./getNetEarningsFiles.gql"),
  GET_LATEST_PAYROLL_ANOMALIES_COUNT: loader("./getLatestPayrollAnomaliesCount.gql"),
  GET_PAYROLL_ANOMALY_DETAILS: loader("./getPayrollAnomalyDetails.gql"),
  GET_PAYROLL_ANOMALY_OUTLIERS: loader("./getPayrollAnomalyOutliers.gql"),
  GET_DIRECT_DEPOSIT_FILES_QUERY: loader("./getDirectDepositFiles.gql"),
  GET_GROSS_EARNINGS_TRANSMISSIONS_FILES_QUERY: loader(
    "./getGrossEarningsTransmissionsFiles.gql"
  ),
  GET_API_RESPONSE_LOGS: loader("./getApiResponseLogs.gql"),
  GET_EMPLOYEE_DISBURSEMENTS: loader("./getEmployeeDisbursements.gql"),
  GET_PROVIDER_DISBURSEMENTS: loader("./getProviderDisbursements.gql"),
  GET_DISBURSEMENTS_REQUSETERS: loader("./getDisbursementsRequesters.gql"),
  GET_EMPLOYER_NOTIFICATION_SETTINGS: loader(
    "./getEmployerNotificationSettings.gql"
  ),
  GET_PROVIDER_METRICS: loader("./getProviderMetrics.gql"),
  GET_METABASE_DASHBOARD: loader("./getMetabaseDashboard.gql"),
  GET_PARTNER_ROLES: loader("./getPartnerRoles.gql"),
  GET_PAY_PERIOD_END_DATES: loader("./getPayPeriodEndDates.gql"),
  GET_DDU_CONSENT_REPORTS: loader("./getDDUConsentReports.gql"),
  GET_PAYSTUB_REPORTS: loader("./getPaystubReports.gql"),
  GET_CASH_BALANCE_REPORTS: loader("./getCashBalanceReports.gql"),
  GET_PAY_PERIOD_PAYMENT_EXPECTED_ON_DATES: loader(
    "./getPayPeriodPaymentExpectedOnDates.gql"
  ),
  GET_PRESETTLEMENT_EXCLUSIONS: loader("./getPresettlementExclusions.gql"),
  GET_BALANCE_DISTRIBUTOR_REPORT: loader("./getBalanceDistributorReport.gql"),
  GET_OPERATING_MANAGERS: loader("./getOperatingManagers.gql"),
  GET_EMPLOYERS: loader("./getEmployers.gql"),
  GET_REMAINING_REWARD_BUDGET: loader("./getRemainingRewardBudget.gql"),
  GET_EMPLOYER_DETAILS: loader("./getEmployerDetails.gql"),
  GET_EMPLOYEE_REWARDS: loader("./getEmployeeRewards.gql"),
  GET_BATCH_DISBURSEMENTS: loader("./getBatchDisbursements.gql"),
  GET_REWARDS: loader("./getRewards.gql"),
};

export default queries;
